import { Switch, Route } from "react-router-dom";

import ChangePassword from "../Screens/ChangePassword/ChangePassword";

export const ResetPasswordRoute = (
    <Switch>
        <Route exact path="/" render={() => <ChangePassword />} />
    </Switch>
);
